import {Link} from "react-router-dom";
import React from "react";
import BookmarkTeam from "../Misc/BookmarkTeam";
import * as Icon from "react-bootstrap-icons";

function Team(props: { team: any, loadData: any }) {
  const {team, loadData} = props;
  const path = `/org/${team.orgId}/team/${team.id}`;

  const isBookmarked = !!team.scopes.find((s: string) => s === "team_user_member" || s === "team_user_guest");

  const style = {
    backgroundImage: `url("${team.imageUrl}")`,
    backgroundSize: "cover"
  };

  return (
    <li className="list-group-item">
      <Link to={path}>
        <div className="row org mt-0 align-items-end" style={style}>
          { team.parcel != null ?
            <div className="hexagon">
              <Icon.HexagonFill size={24} color="#83362B"/>
            </div>
          :
          null}
          <BookmarkTeam teamId={team.id} isBookmarked={isBookmarked} onComplete={loadData}/>
          <div className="col p-0 text-center">
            <div className="m-0 scrim">
              <div className="label">
                {team.name}
              </div>
            </div>
          </div>
        </div>
      </Link>
    </li>
  );
}

export default Team;
